module.exports = __webpack_public_path__ + "static/media/tintas_shows.bfa13b35.webp";